import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { Observable, finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { ModuleTipuriProgramService } from '../module-tipuri-program.service';
import { IAddModulTipProgramPayload, IEditModulTipProgramPayload, IModulTipProgram, IModulTipProgramForm } from '../module-tipuri-program.interface';

@Component({
    selector: 'app-edit-module-tipuri-program',
    templateUrl: './edit-module-tipuri-program.component.html',
    styleUrls: ['./edit-module-tipuri-program.component.scss']
})
export class EditModuleTipuriProgramComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        observatii: new FormControl(this.data.observatii, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IModulTipProgram,
        private dialogRef: MatDialogRef<EditModuleTipuriProgramComponent>,
        private moduleTipuriProgramService: ModuleTipuriProgramService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    submitForm() {
        this.isLoading = true;

        const { name, observatii } = this.form.value as IModulTipProgramForm;
        const payload: IEditModulTipProgramPayload = {
            id_program_type: this.data.id_program_type,
            name,
            observatii
        };

        this.moduleTipuriProgramService
            .updateModulTipProgram(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
